module.exports = __webpack_public_path__ + "img/6.e321df8c.png";